import type { ComponentType } from 'react';
import { widgetRegistry } from '../../infrastructure/registry/WidgetRegistry';
import { WidgetShell } from '../../infrastructure/widgets/WidgetShell';
import { unavailableReason } from '../../widget-state';
import type { WidgetConfig, WidgetProps } from '../../infrastructure/contracts/widget.contract';
import { INCENTIVES_GAP, SURFACE_DEFINITIONS } from './surfaces';

import { SalesEmployeeDashboard } from '../../pages/SalesEmployeeDashboard';
import { DepartmentHeadDashboard } from '../../pages/DepartmentHeadDashboard';
import { SuperAdminDashboard } from '../../pages/SuperAdminDashboard';
import { ITEmployeeDashboard } from '../../pages/ITEmployeeDashboard';
import { ITAdminDashboard } from '../../pages/ITAdminDashboard';
import { MarketingEmployeeDashboard } from '../../pages/MarketingEmployeeDashboard';
import { MarketingAdminDashboard } from '../../pages/MarketingAdminDashboard';
import { DispatchDashboard } from '../../pages/DispatchDashboard';
import { SupportDashboard } from '../../pages/SupportDashboard';
import { OperationalDashboard } from '../../pages/OperationalDashboard';
import { FieldDashboardPage } from '@/features/field/pages/FieldDashboardPage';

/** These screens take no props; they own their own fetching and layout. */
const COMPONENTS: Record<string, ComponentType<WidgetProps>> = {
  'sales.own.surface': () => <SalesEmployeeDashboard />,
  'sales.department.surface': DepartmentHeadDashboard,
  'sales.company.surface': SuperAdminDashboard,
  'it.own.surface': ITEmployeeDashboard,
  'it.department.surface': ITAdminDashboard,
  'marketing.own.surface': MarketingEmployeeDashboard,
  'marketing.department.surface': MarketingAdminDashboard,
  'delivery.surface': DispatchDashboard,
  'support.surface': SupportDashboard,
  'field.surface': FieldDashboardPage,
  'base.own.surface': OperationalDashboard,
  'base.department.surface': DepartmentHeadDashboard,
};

function IncentivesGap(props: WidgetProps) {
  return <WidgetShell title={props.config.title} state="unavailable" reason={unavailableReason(props.config)} />;
}

const base = {
  category: 'utility' as const,
  refreshStrategy: 'onFocus' as const,
  priority: 1,
  defaultSize: { w: 12, h: 12 },
};

let registered = false;

/** Idempotent: called by the dashboard surface and by the registration test. */
export function registerDashboardSurfaces() {
  if (registered) return;
  registered = true;
  for (const surface of SURFACE_DEFINITIONS) {
    const component = COMPONENTS[surface.id];
    if (!component) throw new Error(`Surface ${surface.id} has a definition but no component`);
    widgetRegistry.register(
      { ...base, id: surface.id, title: surface.title, ...surface.config } as WidgetConfig,
      component,
    );
  }
  widgetRegistry.register(
    {
      ...base,
      id: INCENTIVES_GAP.id,
      title: INCENTIVES_GAP.title,
      ...INCENTIVES_GAP.config,
    } as WidgetConfig,
    IncentivesGap,
  );
}
